<template>
  <loading-container :state="state" i18nErrorMessage="views.legalEntities.errorMessage">

    <div v-if="!notFound">
      <div v-if="showOverlay" class="container">
        <div class="row">
          <div class="col-12">
            <div class="redirect-overlay-container">
              <div class="redirect-overlay">
                <h3>{{ $t('detailviews.redirectNote') }} {{ getDomain() }}</h3><br />
                <p>{{ $t('detailviews.redirectNotice1') }} <strong id="redirect-counter-color" class="redirect-counter-color" :data-seconds="$t('detailviews.redirectSeconds')">3 {{ $t('detailviews.redirectSeconds') }}</strong> {{ $t('detailviews.redirectNotice2') }}</p><br />
                <div class="buttons-container">
                  <a @click="goToExternalLink(cCenter, tempCounselingSystem)" class="btn btn-redirect-custom">{{ $t('detailviews.redirectButton') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- breadcrumbs -->
      <div class="container-fluid breadcrumbs d-none d-md-block">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item"><a :href="langMain">{{ $t('detailviews.home') }}</a></li>
                  <li class="breadcrumb-item">
                    <router-link :to="'/'">{{ $t('detailviews.counselingCenters') }}</router-link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">{{ cCenter.name }}</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumbs END -->

      <main id="main" class="">

        <div class="container px-xs-0 pt-2 pt-sm-2 pt-md-0">
          <div class="row">
            <div class="col-12">
              <button role="button" class="btn btn-link btn-back" @click="$router.go(-1)"
                      v-if="routerbacklink === 'y' && routerbacklinkCC !== 'y'" :title="$t('detailviews.backLink')">
                {{ $t('detailviews.backLink') }}
              </button>
              <button role="button" class="btn btn-link btn-back" @click="goToSearch2()"
                      v-if="(routerbacklink === 'y' && routerbacklinkCC === 'y')" :title="$t('detailviews.backLink')">
                {{ $t('detailviews.backLink') }}
              </button>
            </div>
          </div>

          <div class="row mx-0 beratung">

            <div class="col-12 col-headline beratung-headline bg-white text-break">
              <h1>{{ cCenter.name }}</h1>

              <div class="buttons-container float-end">
                <a class="btn btn-counseling-custom" @click="openCounselingUrl(cCenter, 'CHAT')"
                        v-if="cCenter.chatCounselingSystem && cCenter.chatCounselingSystem !== 'NONE'"><i class="icon onb-contact--chat"></i>{{ $t('views.counselingCenters.chatConsult') }}<i class="icon onb-contact--chat-link"></i>
                </a>
                <a class="btn btn-counseling-custom" @click="openCounselingUrl(cCenter, 'VIDEO')"
                        v-if="cCenter.videoCounselingSystem && cCenter.videoCounselingSystem !== 'NONE'"><i class="icon onb-contact--video"></i>{{ $t('views.counselingCenters.videoConsult') }}
                </a>
                <a class="btn btn-counseling-custom" @click="openCounselingUrl(cCenter, 'MAIL')"
                        v-if="cCenter.mailCounselingSystem && cCenter.mailCounselingSystem !== 'NONE'"><i class="icon onb-contact--mail"></i>{{ $t('views.counselingCenters.mailConsult') }}
                </a>
              </div>
            </div>

            <div class="col-12 col-md-5 col-lg-3 mb-3 mt-3 mt-md-0 bg-white beratung-sidebar">

              <div class="beratung-sidebar-block" v-if="cCenter.legalEntities && cCenter.legalEntities.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <div class="icon svg-legalEntity" aria-hidden="true"></div>
                  <h2 class="mb-0">{{ $t('detailviews.legalEntities') }}:</h2>
                </div>
                <div class="block-text" v-for="(rt, index) in cCenter.legalEntities" :key="index">
                  <!-- <router-link v-if="!isFrauen" class="mb-1 d-block" :to="'/legal-entities/'+rt.id" :title="$t('detailviews.openLeLink')">{{ rt.name }}</router-link> -->
                  <router-link
                      v-if="!isFrauen"
                      class="mb-1 d-block"
                      :to="{
                  name: 'legal-entities',
                  params: { leid: rt.id, ccid: cCenter.id, backlink: routerbacklink, backlinkCC: 'y', backUrlHistory: backUrlHistory}
                }"
                      :title="$t('detailviews.openLeLink')"
                  >{{ rt.name }}
                  </router-link>

                  <div v-else class="mb-1 d-block">{{ rt.name }}</div>
                </div>
              </div>

              <div
                  v-if="cCenter.address && (cCenter.address.streetName || cCenter.address.houseNumber || cCenter.address.addressSupplement || cCenter.address.zipCode || cCenter.address.city)"
                  class="beratung-sidebar-block"
              >
                <div class="mb-2 block-head d-flex align-items-center">
                  <div class="icon svg-adresse" aria-hidden="true"></div>
                  <h2 class="mb-0">{{ $t('detailviews.address') }}:</h2>
                </div>
                <div class="block-text">
                  <p>
                    <span v-if="cCenter.address && cCenter.address.streetName">{{ cCenter.address.streetName }}</span>
                    <span v-if="cCenter.address && cCenter.address.houseNumber">&nbsp;{{
                        cCenter.address.houseNumber
                      }}</span><br>
                    <span v-if="cCenter.address && cCenter.address.addressSupplement"> {{
                        cCenter.address.addressSupplement
                      }} <br></span>
                    <span v-if="cCenter.address && cCenter.address.zipCode">{{ cCenter.address.zipCode }}</span> <span
                      v-if="cCenter.address && cCenter.address.city">&nbsp;{{ cCenter.address.city }}</span>
                  </p>
                </div>
              </div>

              <div class="beratung-sidebar-block">
                <div class="beratung-sidebar-block-kontakt">

                  <div class="block-head d-flex align-items-center" v-if="cCenter.phone && cCenter.phone.length > 0"
                       :class="cCenter.phone2 ? 'mb-1': ''">
                    <div class="icon svg-tel" aria-hidden="true"></div>
                    <a :href="formattedPhoneHref(cCenter.phone)" :title="$t('detailviews.telLinkTitle')" class="h3link">{{
                        cCenter.phone
                      }}</a>
                  </div>

                  <div class="block-head d-flex align-items-center" v-if="cCenter.phone2 && cCenter.phone2.length > 0">
                    <div class="icon svg-tel invisible" aria-hidden="true"></div>
                    <a :href="formattedPhoneHref(cCenter.phone2)" :title="$t('detailviews.telLinkTitle')"
                       class="h3link">{{ cCenter.phone2 }}</a>
                  </div>

                  <div class="block-head d-flex align-items-center" v-if="cCenter.email && cCenter.email.length > 0">
                    <div class="icon svg-email" aria-hidden="true"></div>
                    <a rel="noopener" :href="formattedEmailHref(cCenter.email)" :title="$t('detailviews.mailLinkTitle')"
                       class="h3link">{{ $t('detailviews.sendMail') }}</a>
                  </div>

                  <div class="block-head d-flex align-items-center"
                       v-if="cCenter.homepage && cCenter.homepage.length > 0">
                    <div class="icon svg-www" aria-hidden="true"></div>
                    <a :href="formattedUrlHref(cCenter.homepage)" :title="$t('detailviews.urlLinkTitle')"
                       class="h3link extern" rel="noopener nofollow" target="_blank">{{ $t('detailviews.goToUrl') }}</a>
                  </div>
                </div>
              </div>


              <div class="beratung-sidebar-block" v-if="cCenter.openingHours && cCenter.openingHours.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <div class="icon svg-oeffnungszeiten" aria-hidden="true"></div>
                  <h2 class="mb-0">{{ openHoursHeadline }}:</h2>
                </div>
                <div class="block-text oz-list" v-dompurify-html="groupOpeningHours"></div>
              </div>

              <div class="beratung-sidebar-block" v-if="getAvaLang.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <div class="icon svg-sprachen" aria-hidden="true"></div>
                  <h2 class="mb-0">{{ $t('detailviews.moreLangs') }}:</h2>
                </div>
                <div class="block-text">
                  <ul>
                    <li v-for="(lang, index) in getAvaLang" :key="index">
                      {{ lang.description }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="beratung-sidebar-block" v-if="getAvaOffer.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <div class="icon svg-zusatz" aria-hidden="true"></div>
                  <h2 class="mb-0">{{ $t('detailviews.moreOffers') }}:</h2>
                </div>
                <div class="block-text">
                  <ul>
                    <li v-for="(offer, index) in getAvaOffer" :key="index">
                      {{ offer.description }}
                    </li>
                  </ul>
                </div>
              </div>


            </div>

            <div class="col-12 col-md-7 col-lg-6 mb-3 bg-white beratung-content">

              <div lang="de" class="beratung-content-block"
                   v-if="cCenter.information && cCenter.information.length > 0">
                <h2>{{ $t('detailviews.information') }}</h2>
                <div v-dompurify-html="cCenter.information"></div>
              </div><!-- beratung-content-block-->

              <div lang="de" class="beratung-content-block"
                   v-if="cCenter.description && cCenter.description.length > 0">
                <h2>{{ $t('detailviews.description') }}</h2>
                <div v-dompurify-html="cCenter.description"></div>
              </div><!-- beratung-content-block-->

              <div lang="de" class="beratung-content-block" v-if="cCenter.aboutUs && cCenter.aboutUs.length > 0">
                <h2>{{ $t('detailviews.aboutUs') }}</h2>
                <div v-dompurify-html="cCenter.aboutUs"></div>
              </div><!-- beratung-content-block-->

              <div lang="de" class="beratung-content-block"
                   v-if="cCenter.appointmentInfo && cCenter.appointmentInfo.length > 0">
                <div class="btn termin-link w-100 p-3 text-start" v-dompurify-html="cCenter.appointmentInfo"></div>
              </div><!-- beratung-content-block-->

            </div>


            <div class="col-12 col-md-12 col-lg-3 mb-3 mt-md-0 bg-white beratung-sidebar">

              <div class="beratung-sidebar-block sidebar-right" v-if="getAvaCtype.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <h2 class="mb-0">{{ $t('detailviews.counselingType') }}:</h2>
                </div>
                <div class="block-text">
                  <ul>
                    <li v-for="(ctype, index) in getAvaCtype" :key="index">
                      {{ ctype.description }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="beratung-sidebar-block sidebar-right" v-if="getAvaSetting.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <h2 class="mb-0">{{ $t('detailviews.counselingSettings') }}:</h2>
                </div>
                <div class="block-text">
                  <ul>
                    <li v-for="(settings, index) in getAvaSetting" :key="index">
                      {{ settings.description }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="beratung-sidebar-block sidebar-right" v-if="getAvaTarget.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <h2 class="mb-0">{{ $t('detailviews.counselingTarget') }}:</h2>
                </div>
                <div class="block-text">
                  <ul>
                    <li v-for="(tg, index) in getAvaTarget" :key="index">
                      {{ tg.description }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="beratung-sidebar-block sidebar-right" v-if="getAvaTopics.length > 0">
                <div class="mb-2 block-head d-flex align-items-center">
                  <h2 class="mb-0">{{ $t('detailviews.counselingTopics') }}:</h2>
                </div>
                <div class="block-text sidebar-tag-box">
                  <ul class="list-unstyled">
                    <li v-for="(topic, index) in getAvaTopics" :key="index">
                      <div class="tag">
                        {{ topic.description }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>


            </div>

          </div> <!-- /row beratung -->
        </div> <!-- /container -->


      </main>
    </div>
    <div v-else>
      <main id="main" class="">
        <div class="container px-xs-0">
          <div class="row mx-0 beratung">
            <div class="col-12 col-headline bg-white border-0">
              <h2>{{ $t('detailviews.ccNotFound') }}</h2>
            </div>
          </div>
        </div>
      </main>
    </div>
  </loading-container>
  <!-- </loading-container> -->
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {CounselingCenterDetailsDto, CounselingSystemType} from '@/generated/openapi/api';
import counselingCenterService from '@/services/counselingCenterService';
import {mapActions} from "vuex";
import CONFIG from "@/config/config"

import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import LoadingMixin from '@/mixins/LoadingMixin'
import {LoadingState} from '@/utils/loadingUtils'
import { sanitizeUrl } from '@braintree/sanitize-url';

export default defineComponent({
  name: 'ViewCounselingCenter',
  components: {
    LoadingContainer,
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      cCenter: {} as CounselingCenterDetailsDto,
      notFound: false,
      routerRegion: '' as any,
      routerTopics: [] as any,
      routerbacklink: '',
      tagUrl: CONFIG.tagUrl,
      langMain: 'de',
      topics: '' as any,
      region: '' as any,
      lang: '' as any,
      cType: '' as any,
      targetGroup: '' as any,
      routerbacklinkCC: '' as any,
      backUrlHistory: '' as any,
      CounselingSystemType,
      showOverlay: false,
      tempCounselingSystem: ''
    }
  },
  mounted() {

    const tempLang = (document && document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].getAttribute('lang')) || 'de';
    if (tempLang === 'en') {
      this.langMain = '/en/'
    } else {
      this.langMain = '/'
    }

    window.scrollTo(0, 0);

    this.state = LoadingState.loading
    this.getAllLookUpValues().then(_ => {
      //this.state = LoadingState.success
    }).catch(_ => {
      this.state = LoadingState.error
    });

    // console.log("xxx:",this.$store.state.lookUpValues)

    if (this.$route.params.region !== "noregion") {
      this.routerRegion = this.$route.params.region
    } else {
      this.routerRegion = '';
    }

    if (this.$route.params.backlink) {
      if (typeof this.$route.params.backlink === "string") {
        this.routerbacklink = this.$route.params.backlink
      }
    }

    if (this.$route.params.backlinkCC) {
      if (typeof this.$route.params.backlinkCC === "string") {
        this.routerbacklinkCC = this.$route.params.backlinkCC
      }
    }

    if (this.$route.params.backUrlHistory) {
      if (typeof this.$route.params.backUrlHistory === "string") {
        this.backUrlHistory = this.$route.params.backUrlHistory
      }
    }

    // console.log('backlink:',this.routerbacklink)

    //console.log('router-topics:', this.routerTopics)
    //console.log('router-region:', this.routerRegion)

    if (this.routerbacklinkCC !== 'y' && this.routerbacklink === 'y') {
      this.backUrlHistory = window.history.state.back;
    }
    // console.log('bakurlhistory:',this.backUrlHistory, window.history.state)

    //load data
    this.loadCounselingCenter()
  },
  methods: {

    ...mapActions(['getAllLookUpValues']),

    setHTMLTitle() {
      let titleOri = document.title;
      if (titleOri.length == 0 || titleOri === "") {
        titleOri = this.$t("detailviews.consultation");
      }
      const title = titleOri.split('-');
      document.title = this.cCenter.name + " - " + title[title.length - 1];
    },

    loadCounselingCenter() {
      // this.state = LoadingState.loading
      const ccId = this.$route.params.ccid.toString()

      sessionStorage.setItem("lastCC", `${ccId}`);

      if (ccId) {
        counselingCenterService.getCounselingCenter(ccId).then(ccEnt => {
          this.cCenter = ccEnt
          this.notFound = false;
          this.state = LoadingState.success
          this.setHTMLTitle();
        }).catch(() => {
          //console.log('error load ccenter')
          this.notFound = true;
          this.state = LoadingState.error
        })
      } else {
        this.notFound = true;
        this.state = LoadingState.success
      }

    },

    goToSearch2() {
      // console.log('click2',this.backUrlHistory)
      this.$router.push(this.backUrlHistory)
    },

    formattedUrlHref(url?: string): string | undefined {
      if (url) {
        return sanitizeUrl(url);
      }
      return undefined;
    },

    formattedEmailHref(email?: string): string | undefined {
      if (email) {
        return `mailto:${sanitizeUrl(email)}`;
      }
      return undefined;
    },

    formattedPhoneHref(phone?: string): string | undefined {
      if (phone) {
        return `tel:${this.sanitizePhoneNumber(phone)}`;
      }
      return undefined;
    },

    sanitizePhoneNumber(phone: string): string {
      return phone.replace(/[^0-9+()\-.\s]/g, '');
    },

    getAccountLink() {
      const account = document.getElementById('widgetergebnisliste');
      if (account) {
        const infoLink = account.getAttribute('data-account-link');
        if (infoLink) {
          return infoLink;
        }
      }
      return "";
    },
    getDomain() {
      return window.location.hostname;
    },
    goToExternalLink(center: any, counselingSystem: string) {
      this.showOverlay = true;
      if (counselingSystem == 'MAIL') {
        window.location.href = center.mailConfig;
      }
      if (counselingSystem == 'CHAT') {
        window.location.href = center.chatConfig;
      }
      if (counselingSystem == 'VIDEO') {
        window.location.href = center.videoConfig;
      }
    },
    showRedirectOverlay(url: string) {
      this.showOverlay = true;
      let countdown = 3;

      let interval = setInterval(function () {
        countdown--;
        if (countdown == 0) {
          clearInterval(interval);
          window.location.href = url;
        } else {
          let element = document.getElementById("redirect-counter-color");
          if (element) {
            const secondsLabel = element.dataset.seconds;
            if (countdown == 1) {
              if (secondsLabel) {
                (element as HTMLElement).innerHTML = countdown + " " + secondsLabel.substring(0, secondsLabel.length - 1);
              } else {
                (element as HTMLElement).innerHTML = countdown + " Sekunde";
              }
            } else {
              if (secondsLabel) {
                (element as HTMLElement).innerHTML = countdown + " " + secondsLabel;
              } else {
                (element as HTMLElement).innerHTML = countdown + " Sekunden";
              }
            }
          }
        }
      }, 1000);

    },
    openCounselingUrl(center: any, counselingSystem: string) {
      if (!center) return;

      this.tempCounselingSystem = counselingSystem

      if (counselingSystem == 'MAIL') {this.tempCounselingSystem = counselingSystem
        if (center.mailCounselingSystem && center.mailCounselingSystem == 'EXTERNAL') {
          this.showRedirectOverlay(center.mailConfig);
          //window.open(center.mailConfig, '_blank');
        }

        if (center.mailCounselingSystem && center.mailCounselingSystem == 'INTERNAL') {
          if (this.getAccountLink()) {
            window.location.href = this.getAccountLink();
          } else {
            this.$router.push('/account');
          }
        }
      }

      if (counselingSystem == 'CHAT') {
        if (center.chatCounselingSystem && center.chatCounselingSystem == 'EXTERNAL') {
          this.showRedirectOverlay(center.chatConfig);
          //window.open(center.chatConfig, '_blank');
        }

        if (center.chatCounselingSystem && center.chatCounselingSystem == 'INTERNAL') {
          if (this.getAccountLink()) {
            window.location.href = this.getAccountLink();
          } else {
            this.$router.push('/');
          }
        }
      }

      if (counselingSystem == 'VIDEO') {
        if (center.videoCounselingSystem && center.videoCounselingSystem == 'EXTERNAL') {
          this.showRedirectOverlay(center.videoConfig);
          //window.open(center.videoConfig, '_blank');
        }

        if (center.videoCounselingSystem && center.videoCounselingSystem == 'INTERNAL') {
          if (this.getAccountLink()) {
            window.location.href = this.getAccountLink();
          } else {
            this.$router.push('/');
          }
        }
      }

    }
  },
  computed: {

    getAvaLang(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.LANGUAGE) {
          return this.cCenter.lookupValues.LANGUAGE
        }
      }
      return ''
    },
    getAvaTarget(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.TARGET_GROUP) {
          return this.cCenter.lookupValues.TARGET_GROUP
        }
      }
      return ''
    },
    getAvaSetting(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.SETTING) {
          return this.cCenter.lookupValues.SETTING
        }
      }
      return ''
    },
    getAvaOffer(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.OFFER) {
          return this.cCenter.lookupValues.OFFER
        }
      }
      return ''
    },
    getAvaCtype(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.COUNSELING_TYPE) {
          return this.cCenter.lookupValues.COUNSELING_TYPE
        }
      }
      return ''
    },
    getAvaTopics(): any {
      if (this.cCenter.lookupValues) {
        if (this.cCenter.lookupValues.TOPIC) {
          return this.cCenter.lookupValues.TOPIC
        }
      }
      return ''
    },

    getReturnUrl(): string {
      let urlString = '?';
      for (let i = 0; i < this.routerTopics.length; i++) {
        urlString = urlString + "topic=" + this.routerTopics[i] + "&"
      }
      if (this.routerRegion) {
        urlString = urlString + "region=" + this.routerRegion
      }
      return urlString
    },
    openHoursHeadline(): string {
      if (document && document.body && document.body.classList.contains("frauen")) {
        return this.$t('detailviews.openingHoursFrauen')
      } else {
        return this.$t('detailviews.openingHoursFamilie')
      }
    },
    isFrauen(): boolean {
      if (document && document.body && document.body.classList.contains("frauen")) {
        return true
      } else {
        return false
      }
    },
    groupOpeningHours(): string {

      let openHourString = '';
      if (this.cCenter.openingHours) {
        for (let i = 0; i < this.cCenter.openingHours.length; i++) {
          if (i > 0 && (this.cCenter.openingHours[i].dayOfWeek === this.cCenter.openingHours[i - 1].dayOfWeek)) {
            openHourString = openHourString + '<div><span class="oz-day"></span> ' + this.cCenter.openingHours[i].openingTime?.substring(0, 5) + ' - ' + this.cCenter.openingHours[i].closingTime?.substring(0, 5);
          } else {
            openHourString = openHourString + '<div><span class="oz-day">' + this.$t("common.weekdaysShort." + this.cCenter.openingHours[i].dayOfWeek) + '</span> ' + this.cCenter.openingHours[i].openingTime?.substring(0, 5) + ' - ' + this.cCenter.openingHours[i].closingTime?.substring(0, 5);
          }
          if (this.cCenter.openingHours[i].description) {
            openHourString = openHourString + '<span class="oz-zusatz" v-if="day.description">(' + this.cCenter.openingHours[i].description + ')</span>'
          }
          openHourString = openHourString + '</div>';
        }
      }
      return openHourString
    }
  }

});
</script>

<style>
/* .beratung-content-block p{
  margin-bottom: 0px;
} */

/* .termin-link p:last-of-type{
  margin-bottom: 0px;
} */

.buttons-container {
  display: flex;
  gap: 10px; /* Adjusts the space between buttons */
}

.termin-link {
  padding-bottom: 0px;
}

.btn-back {
  margin-top: -10px;
  margin-bottom: 10px;
  font-size: 14px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #000;
  text-decoration: none;
  text-underline-offset: 3px;
}

.btn-back:hover {
  text-decoration: underline;
  color: #000;
}

@media screen and (min-width: 576px) {
  .btn-back {
    padding-left: 0px;
  }
}

.btn-back::before {
  content: "❮";
  margin-right: 6px;
  text-decoration: none;
  display: inline-block;
}

.btn-back::before {
  content: "❮";
  margin-right: 6px;
  text-decoration: none;
}

.btn-back:focus {
  outline: 1px solid black;
  box-shadow: none;
}

@media screen and (min-width: 576px) and (max-width: 767px) {
  .btn-back {
    padding-top: 25px;
  }
}

.frauen .beratung-content-block .termin-link ul li::before {
  color: #870038 !important
}

.familie .beratung-content-block .termin-link ul li::before {
  color: #217cab !important
}

.redirect-overlay-container {
  position: relative;
}

.redirect-overlay {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  background-color: #FFF;
  z-index: 99999;
  padding: 20px;
}

</style>
